import { CodeSystem } from 'context/elasticsearch/types'
import { codesystemsEndpointName } from 'utils'

const smallLabCodesystems = [
	CodeSystem.anatomisk,
	CodeSystem.provemateriale,
	CodeSystem.tekstligeresultatverdier,
	CodeSystem.undersokelsesmetode,
]

const isSmallLabCodesystem = (codeSystem: CodeSystem) => {
	return smallLabCodesystems.some((codesystem) => codesystem === codeSystem)
}

export default isSmallLabCodesystem
